import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DocumentsService, ExtUsersService, PafDocument, SharedDataService } from 'ngx-paf-common';
import { AuthState } from 'src/app/Models_Extranet/AuthState';
import { AuthenticationService } from 'src/app/SERVICES/authentication.service';
import { saveAs } from '@progress/kendo-file-saver';
import { Subscription } from 'rxjs';
import * as moment from 'moment';

@Component({
  selector: 'logged-callback',
  template: '<span></span>',
  styleUrls: []
})
export class LoginCallbackComponent implements OnInit, OnDestroy {

  subs : Subscription[]=[];
  constructor(
    private extUsersService: ExtUsersService,
    private docsSvc: DocumentsService,
    private authSvc: AuthenticationService,
    private router: Router,
    public sharedDataSvc: SharedDataService) {

  }
  ngOnDestroy(): void {
    this.subs.forEach(s=>s.unsubscribe());
  }

  async ngOnInit() {
    if (!this.authSvc.getAccessToken()) {
      // l'échange a échoué
      this.router.navigate(['login-required']);
      return;
    }
    await this.initWithRef();
  }

  

  stopRfePopup?: boolean;

  async initWithRef(){
    await this.sharedDataSvc.awaitForRefloaded();
    await this.sharedDataSvc.awaitForExtUserloaded();
    await this._popupRfeIfRequired();
    const urls = this.RedirectNavigation();
    if (urls) {
      this.router.navigate(urls);
    }

  }

  private RedirectNavigation(): string[] {
    const state = this.authSvc.retrieveAuthenticationState();
    if (state) {
      const params = new URLSearchParams(state);
      const encoded = params.get('pafState');

      if (encoded) {
        const decoded = decodeURIComponent(encoded);
        const pafState: AuthState = JSON.parse(decoded);
        return pafState.url.split(',');
      }
    }
    return ['suppliers'];
  }

  async _popupRfeIfRequired(): Promise<void> {
      if (this.sharedDataSvc.loggedExtUser?.TopRFE != true) {
        this.stopRfePopup = false;
        await this.afficherPopup();
        await this.stopRfeAlertIfRequested();
      }
  }

  async stopRfeAlertIfRequested():Promise<void> {
    if (this.stopRfePopup != true) return;
    return new Promise<void>((resolve)=>{
      this.sharedDataSvc.WindowLock();
      this.extUsersService.CheckRFE(this.sharedDataSvc.loggedExtUser.Id).subscribe({
        next:()=>{
          this.sharedDataSvc.loggedExtUser.TopRFE = true;
          this.sharedDataSvc.WindowUnlock();
          resolve && resolve();
        },
        error:(reason)=>{
          this.sharedDataSvc.alertSubscriptionReject(reason);
          resolve && resolve();              
        }
      });
    });
  }



  afficherPopup(): Promise<void> {
    return new Promise((resolve) => {
      const html = this.sharedDataSvc.getLoadedLabel('Pop_RFE_body'); 
      const title = this.sharedDataSvc.getLoadedLabel('Pop_RFE_title');
      this.sharedDataSvc.alert(
        html,      // msg
        () => resolve && resolve(),                 // nextCallBack
        '',               // icon
        title,                 // title
        {minWidth:'800px'},
        [                     // clickHandlers
          {
            id: 'lnk-rfe-pdf',
            event : 'click',
            handler: (e) => this.btnDownloadRfe(e)
          },                    // clickHandlers
          {
            id: 'chk-stop-alert-rfe',
            event : 'change',
            handler: (e) => this.chkStopRfeAlertChange(e)
          }
        ]
      );
    });
  }


  btnDownloadRfe(event: Event): void {
    event.preventDefault();
    this.docsSvc.getPafDocuments()
      .subscribe((pds: PafDocument[]) => {
        let docRfe = pds.find(d => d.Cod == 'RFE_FACT_ELECTRONIQUE');
        if (!docRfe) {
          this.sharedDataSvc.alert(`Le modèle ayant pour code 'RFE_FACT_ELECTRONIQUE' est introuvable en base.`);
          return;
        }
        this.sharedDataSvc.WindowLock();
        this.docsSvc.downloadTemplate(docRfe.Id)
          .subscribe({
            next:blob => {
              this.sharedDataSvc.WindowUnlock();
              saveAs(blob, docRfe.TemplatePath);
            },
            error:(reason)=>this.sharedDataSvc.alertSubscriptionReject(reason)
          });
      });
  }

  chkStopRfeAlertChange(e:Event): void {    
    this.stopRfePopup = (e.target as HTMLInputElement).checked;
  }

}
